import { useGetBackgroundImageQuery, useLayoutWidth } from 'app/imports/App.hooks'
import { selectBackgroundImage } from 'app/imports/App.selectors'
import IconLogoBg from 'assets/img/logo_csz.png'
import { ReactNode, useMemo } from 'react'
import { useSelector } from 'react-redux'
import * as Styled from './LayoutContent.styled'

export function LayoutContent({ children }: { children: ReactNode }) {
  const layoutWidth = useLayoutWidth()
  const backgroundImageId = useSelector(selectBackgroundImage)

  const { data, isFetching, isError } = useGetBackgroundImageQuery(backgroundImageId || '', {
    skip: !backgroundImageId,
  })

  const bgImage = useMemo(() => {
    if (!backgroundImageId) return IconLogoBg

    if (isFetching) return ''

    if (isError || !data?.url) return IconLogoBg

    return data.url
  }, [backgroundImageId, isFetching, isError, data?.url])

  return (
    <Styled.ContentContainer $bgImage={bgImage} $layoutWidth={layoutWidth}>
      <Styled.Content>{children}</Styled.Content>
    </Styled.ContentContainer>
  )
}
